<template>
  <div id="user-layout">
    <div class="logo">
      <img src="../assets/images/logo.png" alt="logo" />
    </div>
    <route-view />
  </div>
</template>

<script>
import RouteView from './RouteView.vue';

export default {
  name: 'UserLayout',
  components: {
    RouteView,
  },
};
</script>

<style lang="stylus" scoped>
@import '~assets/css/mixins'
#user-layout
  position relative
  width 100%
  height 100%
  flex-row-nowrap()
  .logo
    position absolute
    top 40px
    left 100px
    color #ffffff
    z-index 999
    img
      height 47px
</style>
